import axios from "axios";
import {
	forceLogout,
	getAccessToken,
	refreshAccessToken,
} from "@/services/authService";

export default class BaseAPIClient {
	instance = null;

	constructor() {
		this.createInstance();
		this.setInterceptors();
	}

	createInstance() {
		this.instance = axios.create({
			headers: {
				"Content-Type": "application/json",
			},
			withCredentials: true,
			timeout: 1000 * 60 * 60 * 24,
		});
	}

	setInterceptors() {
		// Request interceptor: attach current access token
		this.instance.interceptors.request.use(async (config) => {
			const token = getAccessToken();
			if (token) {
				config.headers.Authorization = `Bearer ${token}`;
			}

			if (config.method === "get") {
				config.headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
				config.headers.Pragma = "no-cache";
				config.headers.Expires = "0";
			}

			return config;
		});

		// Response interceptor: handle 401 with token refresh via auth-api
		this.instance.interceptors.response.use(
			(response) => response,
			async (error) => {
				const originalRequest = error.config;

				if (error.response?.status === 401 && !originalRequest._retry) {
					originalRequest._retry = true;

					try {
						const newToken = await refreshAccessToken();
						originalRequest.headers.Authorization = `Bearer ${newToken}`;
						return this.instance(originalRequest);
					} catch {
						// Refresh failed — clear state and redirect to login
						forceLogout();
					}
				}

				return Promise.reject(error);
			},
		);
	}
}
